<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :backButtonEnable="false"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderContentStatic
        title="Work Orders"
        :screenName="'Work Orders - Actual Costs'"
      />
    </template>

    <div class="css-v2 grid-report">
      <gc-data-grid-report
        v-if="report.dataSourceConfig"
        :exportFileName="report.exportFileName"
        :dataSourceConfig="reportDataSourceConfig"
        :columns="columns"
        :gridOptions="gridOptions"
        :persistenceKey="persistenceKey"
        :heightPadding="20"
        :gridToolbar="gridToolbar"
        :ref="'actual-costs'"
      >
      </gc-data-grid-report>
      <GcPopUpWorkOrder
        :popupConfig="popup"
        :on-hide="onPopupHide"
        :wrapper-attr="{
          class: 'css-v2 gc-popup gc-popup-form gc-popup-work-order',
        }"
        :data-model="dataModel"
        :show-loading="ShowLoading"
        :width="1024"
        :height="370"
        :save-call-back="onWorkOrderSave"
        :displayServerError="displayServerErrorOnTemplate"
        v-if="popup.isPopupShow"
      />
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import GcDataGridReport from "@/components/gc-data-grid-report";
import { ScreenLayoutService } from "@/_services/api/reports/screen-layout.service";
import { CommonStorage } from "../../../../_services/storage";
import { WorkOrderService } from "@/_services/api/production/work-order.service";

import {
  WorkOrderTabs,
  GetIndexByTabName,
} from "../../../../_models/tabdata/production/work-order-tabs";

export default {
  props: {
    /**
     * contains report configurations
     */
    reportConfig: {
      type: Object,
      default: undefined,
    },
  },
  mixins: [RouteMixin, FormMixin],
  components: {
    GcDataGridReport,
  },

  data() {
    return {
      persistenceKey: "report-grid-work-order-actual-costs",
      report: {
        title: "",
        exportFileName: "",
        featureCode: "",
        dataSourceConfig: null,
        columns: [],
      },
      gridOptions: {
        // noDataMessage: {
        //   addNew: {
        //     class: "no-data",
        //     title: "No Transactions",
        //     message:
        //       "Currently there are no transactions for customers. Give them a call and sell them something today!",
        //   },
        // },
        options: {
          selectionMode: "none",
          onCellPreparedCallBack: this.onCellPreparedCallBack,
        },
      },
      gridToolbar: {
        search: false,
        columnChooser: true,
        export: true,
        openFilter: true,
        filterOnEnter: true,
      },
      tabs: WorkOrderTabs,
      selectedIndex: GetIndexByTabName("Actual Costs"),

      popup: {
        title: "",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 370,
        isPopupShow: false,
        hideOnOutsideClick: false,
        formMode: "create",
        isEditable: false,
      },
      dataModel: undefined,
    };
  },
  computed: {
    reportDataSourceConfig() {
      var config = this.report.dataSourceConfig;
      // config.filter = [["CustomerCode", "=", this.model.Code]];
      return config;
    },

    columns() {
      var cols = this.report.columns;

      return cols;
    },
  },

  async created() {
    CommonStorage.clear("go_back_route");
    let response = await ScreenLayoutService.getByRoute(
      "report-grid-work-order-actual-costs",
    );
    if (response.data.value) {
      const report = JSON.parse(response.data.value[0].Definition);

      var url = window.location.href;
      if (url.indexOf("?") != -1) {
        if (Object.keys(this.baseView.query).length != 0) {
          CommonStorage.clear("filter-panel-" + this.persistenceKey);
          CommonStorage.clear(this.persistenceKey);
        }
      }

      report.columns.forEach((element) => {
        if (element.screenField === "ScheduledDate") {
          element.filterDefaultValue = undefined;
          element.defaultValue = new Date().addDays(-60);
          element.filterOperator = ">=";
        }

        if (element.screenField === "WorkOrderNo") {
          element.cellTemplate = "HyperLinkText";
          element.activeHyperLink = () => {
            return true;
          };
          element.customHyperLink = (data) => {
            this.onWorkOrderNoClick(data);
          };
        }

        if (element.screenField === "ActualUnitCost") {
        }
      });

      this.report = report;
    }
  },
  methods: {
    /**
     * Show Loading
     * @param value
     * @constructor
     */
    ShowLoading(value) {
      this.showLoading(value);
    },
    /**
     * Show Popup Modal
     */
    showPopupModal() {
      this.popup.popupKey++;
      this.popup.isPopupShow = true;
    },
    /**
     * Show Modal Review
     */
    showModalReview() {
      this.popup.hideOnOutsideClick = true;
      this.popup.formMode = "review";
      this.showPopupModal();
    },
    /**
     * Hide A popup
     */
    onPopupHide() {
      this.popup.isPopupShow = false;
    },
    async onWorkOrderNoClick(data) {
      this.showLoading(true);

      const lineData = data.data;

      const response = await WorkOrderService.getByCode(lineData.WorkOrderNo);

      const workOrderDetail = response.data.value[0];
      this.dataModel = workOrderDetail;
      // this.dataModel.FriendlyStatus = e.data.FriendlyStatus;

      this.popup.title = `Work Order #${workOrderDetail.Code}`;
      this.popup.workOrderCode = workOrderDetail.Code;
      this.popup.secondaryTitle =
        workOrderDetail.ProductCode +
        " - " +
        workOrderDetail.ProductDescription;
      this.popup.isEditable =
        (this.dataModel.FriendlyStatus === "Active" ||
          this.dataModel.FriendlyStatus === "In Production") &&
        FeatureStorage.checkPermission("WorkOrder", "edit");

      this.popup.triggerEdit = false;
      this.popup.displayForScheduleEditing = false;

      this.showLoading(false);

      this.showModalReview();
    },

    onWorkOrderSave(close = true) {
      if (close) {
        this.onPopupHide();
        this.showLoading(true);
      }
      this.$nextTick(() => {
        this.refreshList();
      });
    },
    displayServerErrorOnTemplate(err, msg) {
      this.$store.dispatch("ui/setServerError", {
        error: err,
        title: msg,
      });
    },
    refreshList() {
      this.$refs["actual-costs"].$refs["dataGridReport"].gridRefresh(true);

      this.$nextTick(() => {
        this.showLoading(false);
      });
    },

    onCellPreparedCallBack(e) {
      if (
        e &&
        e.rowType &&
        e.rowType === "data" &&
        e.column &&
        e.column.dataField === "ActualUnitCost"
      ) {
        if (e.data.ActualUnitCost === 0) {
          e.cellElement.style.setProperty("color", "black", "important");
        } else if (e.data.ActualUnitCost < e.data.EstimatedUnitCost) {
          e.cellElement.style.setProperty("color", "green", "important");
        } else if (e.data.ActualUnitCost > e.data.EstimatedUnitCost) {
          e.cellElement.style.setProperty("color", "red", "important");
        } else {
          // e.cellElement.style.color = "black";
        }
      }
    },
  },
};
</script>
